import { BlacklistCheckRequest } from "../../../../types/travel/new-policy/api/BlacklistCheck";

export const createBlacklistCheckRequest = (identificationNumber: string): BlacklistCheckRequest => {
  return {
    identity_number: identificationNumber,
  };
};
